"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.menuItemStyle = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var react_2 = require("@emotion/react");
var material_1 = require("@mui/material");
exports.menuItemStyle = (0, react_2.css)({
    color: 'black',
    textDecoration: 'none',
    fontWeight: 'bold',
    position: 'relative',
});
function MenuItem(_a) {
    var to = _a.to, children = _a.children;
    var theme = (0, material_1.useTheme)();
    return ((0, jsx_runtime_1.jsx)(react_router_dom_1.NavLink, __assign({ to: to, css: exports.menuItemStyle }, { children: function (_a) {
            var isActive = _a.isActive;
            return ((0, jsx_runtime_1.jsx)("span", __assign({ css: {
                    borderBottom: "3px solid ".concat(isActive ? theme.palette.primary.main : 'transparent'),
                } }, { children: children })));
        } })));
}
exports.default = MenuItem;
